import { Core } from "@faire/design-tokens";
import Color from "@faire/web/slate/Color";
import { Pill } from "@faire/web/slate/Filter/styled";
import { getSpacing } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  width: max-content;
  &:focus-visible {
    border-radius: 40px;
  }
`;

export const StyledText = styled(Typography)`
  &&& {
    width: max-content;
  }
`;

export const StyledPill = styled(Pill)<{
  $hoverColor?: Color;
}>`
  padding: ${getSpacing(0, 16)};

  ${({ $hoverColor }) =>
    $hoverColor
      ? css`
          &:hover {
            border: 1px solid ${$hoverColor} !important;
          }
        `
      : null}
`;

export const LoadingTextPlaceholder = styled.div`
  height: 16px;
  width: 115px;
  background-color: ${Core.surface.inverse};
`;
